module.exports = __webpack_public_path__ + "img/your_travel_we_carry.e92e8b5a.png";